export const OFFLINE_CACHE_VERSION = 3;

export const offlineScopeKey = user => `${user?.user_id || ''}:${user?.tenant_id || ''}:${user?.selected_tenant_id ?? '[all/default]'}:${user?.role || ''}`;

export const getOfflineBranchId = () => {
  try {
    const user = JSON.parse(localStorage.getItem('pharmxai_user') || 'null');
    if (user?.selected_tenant_id) return user.selected_tenant_id;
    if (!user || user.platform_owner || ['platform_owner', 'super_admin', 'admin'].includes(user.role)
      || user.permissions?.includes('cross_branch_read')) return null;
    return user.tenant_id || null;
  } catch { return null; }
};

export const assertOfflineBranch = branchId => {
  if (!branchId || branchId !== getOfflineBranchId()) throw new Error('The selected branch changed. Refresh offline data again.');
};